import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jbTabindex',
})
export class JbTabindexPipe implements PipeTransform {
  transform(isFocusable: boolean) {
    return isFocusable ? 0 : -1;
  }
}
